import { Suspense } from 'react';
import { lazyIdle } from "../utils/FPEUtils";
const GuidLinkInner = lazyIdle(() => import("./GuideLinkInner"));

const GuideLink = ({id, type="icon", text, size="small", linkInfo}) => {
  return (
    <Suspense fallback={""}>
      <GuidLinkInner id={id} type={type} text={text} size={size} linkInfo={linkInfo}/>
    </Suspense>
  )
};

export default GuideLink;